module.exports = __webpack_public_path__ + "static/img/88062B_1_C_20210406_LC.37ca04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88062B_1_C_20210406_LC.png
// module id = mUrL
// module chunks = 0